import { Box, Divider, Grid, Pagination, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css'; // import first
import PageContainer from 'src/components/container/PageContainer';
// components
import moment from 'moment';
import { TailSpin } from 'react-loader-spinner';
import { adminAxiosInstance } from 'src/api/axios';
import AdminFilterBox from './AdminFilterBox';
import CSVButton from './components/CSVButton';
import PayoutsTable from './components/PayoutsTable';

const AdminPayout = () => {
  const [details, setDetails] = useState([]);
  const [mainDetails , setMainDetails] = useState([])
  const [parsedPayout, setParsedPayout] = useState([]);
  const [_count, setCount] = useState(0);
  const [searchFilter, setSearchFilter] = useState('');
  const [loader , setLoader] = useState(false);
  const [limit, setLimit] = useState(20);
  const [page, setPage] = useState(1);
  const [csvLimit, setCsvLimit] = useState(500);
  const [firstDateFilter, setfirstDateFilter] = useState(moment());
  const [secondDateFilter, setsecondDateFilter] = useState(moment().add(-1, 'month'));

  const getPayouts = ()=>{
    setLoader(true)
    adminAxiosInstance
      .get(`/product/previous_payouts?search=${searchFilter}&dateStart=${firstDateFilter||''}&dateEnd=${secondDateFilter||''}&limit=${limit}&page=${page}`)
      .then((response) => {
        if ('status' in response && response.status === 200) {
          let { result, count } = response.data;
          
let sortedList = result.filter(i=>i?.modified_history?.changed_on)
.sort((a, b) => {
  const dateA = new Date(a.modified_history.changed_on);
  const dateB = new Date(b.modified_history.changed_on);
  return dateB - dateA;
});
sortedList = sortedList.map(item=>{
    if('changed_on' in item.modified_history){
      item.modified_history['changed_on'] = new Date(item.modified_history['changed_on']).toLocaleDateString().split(',').join() 
    }
    return item
})
          console.log(sortedList);
          setDetails(sortedList);
          setMainDetails(sortedList);
          setCount(count)
          setLoader(false);
          let parsedData = [];
          for (let d of sortedList) {
            parsedData.push(d);
          }
          // setParsedPayout(parsedData);
        }
      });
  }

  useMemo(()=>{
    getPayouts()
  }, [firstDateFilter, secondDateFilter]);
  const latestEntries = (data) => Object.values(
    data.reduce((acc, item) => {
      const { title, modified_history } = item;
      if (
        !acc[title] || 
        new Date(modified_history.changed_on) > new Date(acc[title].modified_history.changed_on)
      ) {
        acc[title] = item; // Update with the latest entry
      }
      return acc;
    }, {})
  );

  const transform_data = (rawData)=>{
    if(!rawData) return []
    for(let data of rawData){
    for(let i of Object.keys(data?.modified_history)){
      data[i] = data.modified_history[i]
    }
    delete data['_id']
    rawData[rawData.indexOf(data)] = data
  }
  console.log(rawData)
  let raw_data = latestEntries(JSON.parse(JSON.stringify(rawData)))
  raw_data = raw_data.map(i=>{
    delete i['modified_history']
    return i
  })
  return raw_data

  }


  // useEffect(() => {
  //   const filtered_data = mainDetails.filter((i) =>
  //     utils.generate_regex(searchFilter.toLowerCase()).test(i.title.toLowerCase()),
  //   );
  //   filtered_data.length ? setDetails(filtered_data) : setDetails(mainDetails);
  //   filtered_data.length ? setParsedPayout(filtered_data) : setParsedPayout(mainDetails);
  // }, [searchFilter]);

  useEffect(() => {
    console.log(mainDetails);
    console.log(details);
  }, [mainDetails, details]);
  const filterInputs = [
    {
      type:'text',
      name:'Campaign Name',
      state:searchFilter,
      setState:setSearchFilter,
      function:()=>{}
    },
    {
      type:'date',
      dateStart:firstDateFilter,
      dateEnd:secondDateFilter,
      setDateStart:setfirstDateFilter,
      setDateEnd: setsecondDateFilter,
      function:()=>{}
    }
  ]
  return (
    <PageContainer
      title="Products History | EarnPati"
      description="this is Earnpati Products History Page"
      sx={{ maxWidth: { xs: '100vw', lg: '70vw' } }}
    >
      <Grid container spacing={1} sx={{ padding: '0 1.5rem' }}>
      <h3>
      Product Change History
      </h3>
        <Grid item xs={12}>
          <AdminFilterBox inputs={filterInputs} submitFunction={getPayouts} sx={{position: 'sticky', top:'70px', paddingTop: '10px', background:'#fff',zIndex:10}}/>
          <Box></Box>
          <Grid item>
          <Stack direction='row' justifyContent={'space-between'}>
          <p>Showing data of past: {' '}{parseInt(moment.duration(firstDateFilter - secondDateFilter).asDays())} days</p>
        
          <Stack direction={'row'}>
            <p sx={{mt:'15px'}}>Limit:</p>
            <TextField
                sx={{width:'25%', margin:'5px'}}
                type='number'
                  placeholder={`Limit`}
                  value={csvLimit}
                  onChange={(e) => setCsvLimit(e.target.value)}
                />
        <CSVButton 
        transformer={transform_data}
        csv_download_url={`/product/previous_payout_bulk?search=${searchFilter}&dateStart=${firstDateFilter||''}&dateEnd=${secondDateFilter||''}&limit=${csvLimit}`}
        filename={`payout_history_${searchFilter}_${new Date().toDateString()}.csv`}
        csvData={parsedPayout}
        setCsvData={setParsedPayout}
        />
          </Stack>
          </Stack>
          </Grid>
          <Divider sx={{ my: 1 }} />
          <Box>
          {
            loader ? 
            <Stack
              justifyContent="center"
              alignItems="center"
              sx={{ width: "75vw", height: "55vh" }}>
                      <TailSpin height={45} width={45} style={{ margin: "auto", background: "#444" }} />
                    </Stack>
          :(
            details?.length &&
            <PayoutsTable
              details={details}
              
            />
            ||
            <Stack
              justifyContent={'center'}
              alignItems={'center'}
              sx={{ width: '75vw', height: '30vh' }}>
              <Typography variant="h4" sx={{textAlign:'center'}}>No Data Found</Typography>
              </Stack>
          )
          }
          </Box>
          <Stack direction="row" alignItems={'center'} justifyContent={'center'} sx={{position:'fixed',bottom:0, right:0, p:2, width:'80%'}}>
                      <Pagination
                        count={Math.round(_count ? _count / limit : 1) || 1}
                        onChange={(e, value) => setPage(value)}
                      ></Pagination>
                    </Stack>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default AdminPayout;
